<template>
  <div class="card-info">
    <div class="info-cover">
      <img
        :src="item.goodsImg"
        class="img-info"
      >
      <span class="info-name">{{ item.goodsName }}</span>
    </div>
    <div class="topping-order">
      <template v-if="!item.goodsCategoryFlag">
        <div
          v-for="(data, index) in listTopping"
          :key="index"
          class="item-topping"
        >
          <span
            class="name-card-order"
            v-html="data.name"
          />
          <span
            v-if="data.price"
            class="price-topping-order"
          >￥{{ $filters.NumFormat(data.price) }}</span>
        </div>
      </template>
      <div
        v-else
        class="item-topping"
      >
        <span class="name-card-order">商品名：<span class="fw-300">{{ item.goodsName }}</span></span>
        <span class="price-topping-order">￥{{ $filters.NumFormat(item.price) }}</span>
      </div>
    </div>
    <div class="footer-order">
      <div class="action-order">
        <div
          class="minus-order"
          @click="handleMinus"
        >
          <img src="@/assets/images/v2/icon-minus-card.svg">
        </div>
        <span class="quantity-order">{{ quantity }}</span>
        <div
          :class="'plus-order'"
          @click="handlPlus"
        >
          <img src="@/assets/images/v2/icon-plus-card.svg">
        </div>
      </div>
      <span class="price-card-order">￥{{ $filters.NumFormat(item.price * item.number) }}</span>
    </div>
    <div class="order-note" style="text-align: unset;" v-if="(item.dailyOrderLimit || item.purchaseLimit) && item.optionIds">
      {{ goodsCategoryName }}の対象ドリンクは、おひとり様{{ goodsCategoryOrder }}杯ご購入いただけます。
    </div>
    <ConfirmModal
      ref="confirmModal"
      title="商品を削除します"
      content="選択した商品をカートから削除します。"
      text-submit="削除する"
      text-cancel="キャンセル"
      @submit="confirmDeleteItem"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import ConfirmModal from '@/components/Modal/ConfirmModal.vue'
import {
  SESSION_COUPON
} from '@/assets/js/coupon'
import transactionGoodsApi from '@/api/transactionGoods.js';
import moment from 'moment'
import categoryApi from '@/api/category.js';
import { ElMessage } from 'element-plus'

export default {
  name: 'CardOrder',
  components: {
    ConfirmModal
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 0
    },
    disableBtnPlus: {
      type: Boolean,
      default: false
    }
  },
  setup (props, {emit}) {
    const quantity = ref(1)
    const totalNumber = ref(0)
    const sessionCoupon = ref([ ...SESSION_COUPON])
    const confirmModal = ref(null)
    const listTransactionGoods = ref([]);
    const isGoodsCategoryOrderChange = ref(false)
    const diffGoodsCategoryOrder = ref(0)
    const labelName = ref(null)
    const goodsCategoryName = ref(null)
    const goodsCategoryOrder = ref(1);

    const labelFixName = ref(null)
    const labelMap = {
      'CREW': 100200,
      'FRIEND': 100201,
      'U22': 100202
    };
    const rankMap = {
      'LOVER': 100100,
      'MASTER': 100101,
      'AMBASSADOR': 100102,
      'LEGEND': 100103,
      'FAMILY': 100104
    };
    const listTopping = computed(() => {
      const dataGood = props.item.dataGood
      let listTopping = []
      if (dataGood.valueSize) {
        const res = {
          name: `サイズ：<span class="fw-300">${dataGood.valueSize.type.toUpperCase()}／${dataGood.valueSize.name}サイズ</span>`,
          price: dataGood.valueSize.price
        }
        listTopping.push(res)
      }

      if (dataGood.valueSweet) {
        const res = {
          name: `甘さ：<span class="fw-300">${dataGood.valueSweet.label}</span>`,
          price: dataGood.valueSweet.price
        }

        listTopping.push(res)
      }

      if (dataGood.valueIce) {
        const res = {
          name: `氷：<span class="fw-300">${dataGood.valueIce.label}</span>`,
          price: dataGood.valueIce.price
        }

        listTopping.push(res)
      }

      if (dataGood.valueTopping.length) {
        const results = dataGood.valueTopping.reduce((result, org) => {
          (result[org.selectOptionGrpId] = result[org.selectOptionGrpId] || []).push(org)
          return result
        }, {})
        for (const [, value] of Object.entries(results)) {
          const res = {
            name: `トッピング: <span class="fw-300">${value[0].name} x${value.length}</span>`,
            price: value[0].price * value.length
          }
          listTopping.push(res)
        }
      }

      return listTopping
    })

    const isObjNotEmpty = (obj) => {
      return Object.keys(obj).length > 0
    }

    const handleMinus = () => {
      const params = {
        type: 'minus',
        number: props.index
      }
      if (quantity.value === 1) {
        confirmModal.value.show()
      } else {
        quantity.value--
        emit('change', params)
      }

      emit('calculate-u22', props.item)
    }

    const confirmDeleteItem = () => {
      sessionCoupon.value.map((e) => {
        sessionStorage.removeItem(e)
      })
      emit('remove', props.index)
      confirmModal.value.closeModal()
    }

    const getInfoGoodsCategory = async () => {
      try {
        const params = { goodsCategoryId: props.item.goodsCategoryId };
        const res = await categoryApi.getGoodsCategoryById(params, true);
        if (res.code === 200) {
          props.item.optionIds = res.data.optionIds;
          props.item.purchaseLimit = res.data.purchaseLimit;

          // goodsCategoryName
          goodsCategoryName.value = res.data.goodsCategoryName || '';

          // goodsCategoryOrder
          goodsCategoryOrder.value = res.data.goodsCategoryOrder || 1;

          if(props.item.goodsCategoryOrder !== res.data.goodsCategoryOrder && res.data.goodsCategoryOrder < props.item.numberU22) {
            isGoodsCategoryOrderChange.value = true;
            diffGoodsCategoryOrder.value = props.item.numberU22 - res.data.goodsCategoryOrder;
          }
          props.item.goodsCategoryOrder = res.data.goodsCategoryOrder;
          props.item.dailyOrderLimit = res.data.dailyOrderLimit;
        }
      } catch (error) {
        ElMessage.error(error.response.data.msg)
      }
    };

    const handlPlus = async () => {
      emit('calculate-u22', props.item)

      // Get info goodsCategory by id 
      await getInfoGoodsCategory();

      // Get info transactionGoods
      const res = listTransactionGoods.value;

      // Total quantity of products purchased
      const totalGoodsNum = (res || [])
          .filter(item => item.goodsNum !== undefined)
          .reduce((sum, item) => sum + (item.goodsNum || 0), 0);

      // Get name U22
      const lstOptionId = props.item.optionIds;

      if(lstOptionId) {
        const allMaps = {
          ...labelMap,
          ...rankMap
        };

        const matchedNames = Object.keys(allMaps).filter(key => lstOptionId.includes(allMaps[key]));
        const resultString = matchedNames.join('、 ');
        labelName.value = resultString;
      }

      // If you try to add more than one item by pressing the + button, an error screen will be displayed and you will be returned to the cart screen.
      if(props.item && props.item.optionIds) {
        if(props.item.purchaseLimit === 1) {
          // 1日1回 & <= goodsCategoryOrder
          if(props.item.dailyOrderLimit === 1) {
            // Only one product can be purchased per day
            if(totalGoodsNum > 0 || props.item.numberU22 >= props.item.goodsCategoryOrder) {
              changeNumMapServer();
              emit('show-dialog-more-u22', props.item.goodsCategoryOrder, labelName.value, goodsCategoryName.value, goodsCategoryOrder.value, true)
              return
            }
          }
          else {
            if((totalGoodsNum + props.item.numberU22) >= props.item.goodsCategoryOrder) {
              changeNumMapServer();
              emit('show-dialog-more-u22', props.item.goodsCategoryOrder, labelName.value, goodsCategoryName.value, goodsCategoryOrder.value, false)
              return
            }
          }
        }
        else {
          // 1日1回
          if(props.item.dailyOrderLimit === 1) {
            // Only one product can be purchased per day, regardless of the quantity
            if(totalGoodsNum > 0) {
              changeNumMapServer();
              emit('show-dialog-more-u22', props.item.goodsCategoryOrder, labelName.value, goodsCategoryName.value, goodsCategoryOrder.value, true)
              return
            }
          }
        }
      }
      if (quantity.value < 5 && !props.disableBtnPlus) {
        const params = {
          type: 'add',
          number: props.index
        }
        quantity.value++
        emit('change', params)
      } else {
        emit('show-dialog-more-order')
      }
    }

    const changeNumMapServer = () => {
      if(isGoodsCategoryOrderChange.value) {
        for (let i = 0; i < diffGoodsCategoryOrder.value; i++) {
          handleMinus();
        }
      }

      // Reset change
      isGoodsCategoryOrderChange.value = false;
      diffGoodsCategoryOrder.value = 0;
    }

    onMounted(async () => {
      if (isObjNotEmpty(props.item)) {
        quantity.value = props.item.number
      }

      await getInfoGoodsCategory();

      // Get goodsNum U22
      const params = { 
        goodsCategoryId: props.item.goodsCategoryId,
        openId: sessionStorage.getItem('openId')
      };
      listTransactionGoods.value = await transactionGoodsApi.getNumTransactionGoodsByOpenId(params);

      const lstOptionId = props.item.optionIds;
        
      if(lstOptionId) {
        const allMaps = {
          ...labelMap,
          ...rankMap
        };

        const matchedNames = Object.keys(allMaps).filter(key => lstOptionId.includes(allMaps[key]));
        labelFixName.value = matchedNames.join('、 ');
      }
    })
    return {
      quantity,
      totalNumber,
      confirmModal,
      sessionCoupon,
      listTopping,
      isObjNotEmpty,
      handleMinus,
      confirmDeleteItem,
      handlPlus,
      changeNumMapServer,
      labelName,
      labelFixName,
      goodsCategoryName,
      goodsCategoryOrder,
    }
  },
}
</script>
